// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__27kja","header":"Messages_header__1ZHvR"};